import { render, staticRenderFns } from "./wishtable.vue?vue&type=template&id=22ced6a1&scoped=true&"
import script from "./wishtable.vue?vue&type=script&lang=js&"
export * from "./wishtable.vue?vue&type=script&lang=js&"
import style0 from "./wishtable.vue?vue&type=style&index=0&id=22ced6a1&scoped=true&lang=less&"
import style1 from "./wishtable.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ced6a1",
  null
  
)

export default component.exports